export default "__VITE_ASSET__CqdVm4pJ__"